import moment from "moment";

export default {
  friendlyTime(value) {
    return value ? moment(value).local().fromNow() : "";
  },
  absoluteTime(value) {
    return value ? moment(value).local().format("LLLL") : "";
  },
  localDateTime(value) {
    return value ? moment(value).local().format("YYYY-MM-DD hh:mm") : "";
  },
  utcDateTime(value) {
    return value ? value.toString().replace("T", " ").substring(0, 16) : "";
  },
  asFloat(value) {
    return value ? value.toFixed(2) : NaN;
  },
};
